/**
 * @file Re-exports the photo slider and its types.
 */
import Slider from "./Slider";

export * from "./Slider";

export default Slider;
